export default __webpack_public_path__ + "static/media/trackinfo_kart.c6cce295.webp";